/* eslint-disable no-process-env */
const processEnv = process.env;
const env = () => processEnv;
export { env };
